module.exports = __webpack_public_path__ + "models/scene4kids.04380b7.txt";